import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import "./styles.css";
import { ConfigProvider } from "antd";
import RegisterEnumeratorContextProvider from "context/RegisterEnumeratorContext.tsx";
import ForgotPasswordContextProvider from "context/ForgotPasswordEnumeratorContext.tsx";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: `"Inter", sans-serif`,
          colorPrimary: "#22AD5C",
        },
      }}
    >
      <ForgotPasswordContextProvider>
        <RegisterEnumeratorContextProvider>
          <App />
        </RegisterEnumeratorContextProvider>
      </ForgotPasswordContextProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
